import { render, staticRenderFns } from "./ViAdmissionCreateDepartment.vue?vue&type=template&id=28e6dce8"
import script from "./ViAdmissionCreateDepartment.vue?vue&type=script&lang=js"
export * from "./ViAdmissionCreateDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports